export default class {
  constructor({ selector, wrapper }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelector(selector)
    this.wrapper = wrapper instanceof HTMLElement ? wrapper : document.querySelector(wrapper)
    //Methods
    this.onResize()
    this.addEventListener()
  }

  addEventListener() {
    window.addEventListener('resize', this.onResize.bind(this), false)
  }

  onResize() {
    this.wrapper.style.height = 'auto'
    this.selector && (this.selector.style.height = `${this.wrapper.offsetHeight}px`)
    this.wrapper.style.height = '100%'
  }

  emitEvent() {
    window.dispatchEvent(new Event('resize'))
  }
}
